import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const profileSettingsPageAccountSectionK = {
  requestAccess: "profile_settings_page_account_section.requestAccess",
  availableForYourProfile: "profile_settings_page_account_section.availableForYourProfile",
  editLogin: "profile_settings_page_account_section.editLogin",
};

export const useProfileSettingsPageAccountSectionT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      requestAccess: t(profileSettingsPageAccountSectionK.requestAccess),
      availableForYourProfile: t(profileSettingsPageAccountSectionK.availableForYourProfile),
      editLogin: t(profileSettingsPageAccountSectionK.editLogin),
    }),
    [i18n.language]
  );
};